export default {
    month: {},
    day: {},
    week: {},
    mySchedule: {},
    currentRota: null,
    staffEmploymentTypes: [],
    currentDate: null
}
